import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/* global toastr */
import React from 'react';
import { compose, withProps, withHandlers, withStateHandlers } from 'recompose';
import _ from 'lodash';
import moment from 'moment';
import { isAfter, differenceInDays, format } from 'date-fns';
import { appIdSelector as appId, intake, intakeEsl, intakeEslOptions, intakeOptions } from '@applyboard/ab-common';
import ApplicationIntake from "./ApplicationIntake";
import { formatDate } from "../../../util/datetime";
import { INTAKE_STATUS_DESCRIPTION, SOURCE_OF_DATE_LABEL } from "../../../constants/consts";
import { isEslGapValid, optionsWithPrevInvalidIntake, getMinEslGapRespectedOptions, generateIntakeTooltip } from "./utils";
import { useEventTracker } from '@applyboard/ui-utils';
var date = function date(d) {
  return formatDate(d, 'YYYY-MMM');
};
var enhancer = compose(
// TODO: remove this after refactoring recompose.  Not doing now since this is
// a complicated enhancer and because of time pressure
// eslint-disable-next-line react/display-name
function (Component) {
  return function (props) {
    var _useEventTracker = useEventTracker(),
      trackEvent = _useEventTracker.trackEvent;
    // eslint-disable-next-line react/react-in-jsx-scope
    return /*#__PURE__*/React.createElement(Component, _extends({
      trackEvent: trackEvent
    }, props));
  };
}, withProps(function (_ref) {
  var application = _ref.application,
    esl = _ref.esl,
    intakes = _ref.intakes,
    intakesESL = _ref.intakesESL;
  var selectedValue = esl ? intakeEsl(application) : intake(application);
  var options = esl ? intakeEslOptions(application) : intakeOptions(application);
  var dropdownOptions = _.map(options, function (option) {
    return {
      option: option,
      value: option.start_date,
      label: date(option.start_date)
    };
  });
  var selectedIntake = null;
  var intakeSpecificStatus = '';
  var deadlineExceptionData = null;
  var openDateExceptionData = null;
  var newAppException = null;
  if (esl) {
    var _selectedIntake;
    selectedIntake = intakesESL && intakesESL.filter(function (intakeESL) {
      return intakeESL.startDate === application.intake_esl;
    })[0];
    intakeSpecificStatus = (_selectedIntake = selectedIntake) === null || _selectedIntake === void 0 ? void 0 : _selectedIntake.specificStatus;

    // The data have exception date, source and confirmation date, respectively
    deadlineExceptionData = selectedIntake && selectedIntake.specificDeadlineExceptions[0];
    openDateExceptionData = selectedIntake && selectedIntake.specificOpendateExceptions[0];
    newAppException = selectedIntake && selectedIntake.specificAcceptingNewAppsExceptions;
  } else {
    var _selectedIntake2, _selectedIntake3, _selectedIntake4, _selectedIntake5;
    selectedIntake = intakes && intakes.filter(function (intake) {
      return intake.startDate === application.intake;
    })[0];
    intakeSpecificStatus = (_selectedIntake2 = selectedIntake) === null || _selectedIntake2 === void 0 ? void 0 : _selectedIntake2.specificStatus;

    // The data have exception date, source and confirmation date, respectively
    deadlineExceptionData = ((_selectedIntake3 = selectedIntake) === null || _selectedIntake3 === void 0 ? void 0 : _selectedIntake3.specificDeadlineExceptions) && selectedIntake.specificDeadlineExceptions[0];
    openDateExceptionData = ((_selectedIntake4 = selectedIntake) === null || _selectedIntake4 === void 0 ? void 0 : _selectedIntake4.specificOpendateExceptions) && selectedIntake.specificOpendateExceptions[0];
    newAppException = (_selectedIntake5 = selectedIntake) === null || _selectedIntake5 === void 0 ? void 0 : _selectedIntake5.specificAcceptingNewAppsExceptions;
  }
  var intakeHasDeadlineException = Array.isArray(deadlineExceptionData) && deadlineExceptionData.length > 0;
  var intakeHasOpenDateException = Array.isArray(openDateExceptionData) && openDateExceptionData.length > 0;
  var hasIntakeExceptions = intakeHasDeadlineException || intakeHasOpenDateException;
  var intakeInfoTooltip = '';
  var openDate = null;
  var sourceOpenDate = null;
  var confirmedOpenDate = null;
  var submissionDeadline = null;
  var sourceDeadline = null;
  var confirmedDeadline = null;
  if (selectedIntake) {
    var _deadlineExceptionDat;
    // The program intake serializer exposes internal data for admin users
    sourceDeadline = selectedIntake.submissionDeadlineSourceOfDate;
    confirmedDeadline = selectedIntake.submissionDeadlineConfirmedAt;
    sourceOpenDate = selectedIntake.openDateSourceOfDate;
    confirmedOpenDate = selectedIntake.opendateConfirmedAt;
    if (confirmedDeadline) {
      confirmedDeadline = formatDate(confirmedDeadline, 'MMM DD, YYYY');
    }
    if (confirmedOpenDate) {
      confirmedOpenDate = formatDate(confirmedOpenDate, 'MMM DD, YYYY');
    }

    // Override if open date exception applies
    if (intakeHasOpenDateException) {
      openDate = openDateExceptionData[0];
      if (openDateExceptionData.length > 1) {
        sourceOpenDate = openDateExceptionData[1];
        confirmedOpenDate = openDateExceptionData[2];
      }
    } else {
      openDate = selectedIntake.openDate;
      if (openDate) {
        openDate = moment(openDate).format('MMM DD, YYYY');
      }
      if (confirmedOpenDate) {
        confirmedOpenDate = moment(confirmedOpenDate).format('MMM DD, YYYY');
      }
    }
    submissionDeadline = formatDeadline(esl ? application.esl_submission_deadline : application.academic_submission_deadline);
    // Override if submission deadline exception applies
    if (((_deadlineExceptionDat = deadlineExceptionData) === null || _deadlineExceptionDat === void 0 ? void 0 : _deadlineExceptionDat.length) > 1) {
      sourceDeadline = deadlineExceptionData[1];
      confirmedDeadline = deadlineExceptionData[2];
    }
    intakeInfoTooltip = generateIntakeTooltip({
      intakeSpecificStatus: intakeSpecificStatus,
      sourceDeadline: sourceDeadline,
      confirmedDeadline: confirmedDeadline,
      submissionDeadline: submissionDeadline
    });

    // TBD scenario
    if (intakeSpecificStatus !== 'waitlist' && !submissionDeadline) {
      intakeInfoTooltip = 'We’re not able to calculate deadline at the moment. Please check later.';
    } else {
      // TODO: move this thick if statement into generateIntakeTooltip and use the early return pattern
      if (intakeSpecificStatus && intakeSpecificStatus.includes('open') && intakeSpecificStatus !== 'likely_open') {
        intakeInfoTooltip += openDate;
        if (sourceOpenDate) {
          intakeInfoTooltip += " (Source: ".concat(SOURCE_OF_DATE_LABEL[sourceOpenDate]);
          intakeInfoTooltip += confirmedOpenDate ? " - Confirmation Date: ".concat(confirmedOpenDate, ")") : ')';
        }
        if (submissionDeadline) {
          intakeInfoTooltip += "\n\n".concat(INTAKE_STATUS_DESCRIPTION.submission_deadline).concat(submissionDeadline);
          if (sourceDeadline) {
            intakeInfoTooltip += " (Source: ".concat(SOURCE_OF_DATE_LABEL[sourceDeadline]);
            intakeInfoTooltip += confirmedDeadline ? " - Confirmation Date: ".concat(confirmedDeadline, ")") : ')';
          }
        }
      } else if (intakeSpecificStatus && intakeSpecificStatus.includes('closed')) {
        if (!selectedIntake.available) {
          intakeInfoTooltip = 'This intake is closed to all applications for all students';
        } else if (!selectedIntake.acceptingNewApps && !application.paid || Array.isArray(newAppException) && newAppException.length > 0) {
          intakeInfoTooltip = 'Based on your profile information, this intake is currently unavailable';
        } else {
          intakeInfoTooltip = intakeInfoTooltip.split('SUBMISSION_DEADLINE');
          intakeInfoTooltip.splice(1, 0, submissionDeadline);
          intakeInfoTooltip = intakeInfoTooltip.join('');
          if (sourceDeadline) {
            intakeInfoTooltip += " (Source: ".concat(SOURCE_OF_DATE_LABEL[sourceDeadline]);
            intakeInfoTooltip += confirmedDeadline ? " - Confirmation Date: ".concat(confirmedDeadline, ")") : ')';
          }
        }
      } else if (intakeSpecificStatus && intakeSpecificStatus.includes('likely_open')) {
        if (submissionDeadline) {
          intakeInfoTooltip += "\n\n".concat(INTAKE_STATUS_DESCRIPTION.submission_deadline).concat(submissionDeadline);
          if (sourceDeadline) {
            intakeInfoTooltip += " (Source: ".concat(SOURCE_OF_DATE_LABEL[sourceDeadline]);
            intakeInfoTooltip += confirmedDeadline ? " - Confirmation Date: ".concat(confirmedDeadline, ")") : ')';
          }
        }
      }

      // show TBD if the user just selected a new intake
      if (esl && Number(selectedIntake.id) !== application.esl_intake_id || !esl && Number(selectedIntake.id) !== application.intake_id) {
        intakeInfoTooltip = 'We’re not able to calculate deadline at the moment. Please check later.';
      }
    }
  }
  return {
    dropdownOptions: dropdownOptions,
    selectedValue: selectedValue,
    tooltipId: "".concat(appId(application), "-").concat(esl ? 'esl' : 'academic', "-tooltip"),
    intakeSpecificStatus: intakeSpecificStatus,
    hasIntakeExceptions: hasIntakeExceptions,
    intakeInfoTooltip: intakeInfoTooltip
  };
}), withProps(function (_ref2) {
  var dropdownOptions = _ref2.dropdownOptions,
    selectedValue = _ref2.selectedValue;
  var newDropdownOptions = _.map(dropdownOptions, function (date) {
    return {
      label: formatDate(date.option.start_date, 'YYYY - MMM.'),
      option: {
        available: date.option.available,
        deadline: date.option.deadline,
        startDate: date.option.start_date
      },
      value: date.option.start_date
    };
  });
  var dateIndex = _.findIndex(dropdownOptions, function (option) {
    return option.value === selectedValue;
  });
  if (dateIndex == -1 && selectedValue) {
    newDropdownOptions.push({
      label: formatDate(selectedValue, 'YYYY - MMM.'),
      option: {
        available: false,
        deadline: selectedValue,
        startDate: selectedValue
      },
      value: selectedValue
    });
  }
  var selectedOption = _.find(newDropdownOptions, function (option) {
    return option.value === selectedValue;
  });
  return {
    dropdownOptions: newDropdownOptions.sort(function (a, b) {
      return a.value.localeCompare(b.value);
    }),
    dropdownValue: selectedOption && selectedOption.value
  };
}), withProps(function (_ref3) {
  var dropdownOptions = _ref3.dropdownOptions,
    dropdownValue = _ref3.dropdownValue;
  return {
    dateIndex: _.findIndex(dropdownOptions, function (option) {
      return option.value === dropdownValue;
    })
  };
}), withProps(function (_ref4) {
  var dropdownOptions = _ref4.dropdownOptions,
    dateIndex = _ref4.dateIndex,
    isApplicationSummary = _ref4.isApplicationSummary;
  return {
    available: dropdownOptions && dropdownOptions[dateIndex] && dropdownOptions[dateIndex].option.available,
    deadline: dropdownOptions && dropdownOptions[dateIndex] && formatDate(dropdownOptions[dateIndex].option.deadline, 'YYYY-MMM-DD'),
    isApplicationSummary: isApplicationSummary
  };
}), withHandlers({
  dropdownChange: function dropdownChange(_ref5) {
    var onChange = _ref5.onChange,
      application = _ref5.application,
      esl = _ref5.esl,
      intakes = _ref5.intakes,
      intakesESL = _ref5.intakesESL,
      trackEvent = _ref5.trackEvent;
    return function (option) {
      var _intakes$find, _intakesESL$find;
      if (!application || !intakes || application.program_esl && esl && !intakesESL) {
        toastr.error('There was a problem updating intake, please try reloading the page.');
        trackEvent({
          event: 'Single Application - Application Intake - Failed To Load Program Intakes',
          error: new Error("Failed to load intakes, application:".concat(!!application, ", intakes:").concat(!!intakes, ", esl:").concat(!!esl, ", intakesESL:").concat(!!intakesESL))
        });
        return;
      }
      if (!option) {
        if (application.program_esl && esl) {
          onChange(null, null);
        } else {
          toastr.error('There was a problem updating intake, please try reloading the page.');
          trackEvent({
            event: 'Single Application - Application Intake - Failed To Load Program Intakes',
            error: new Error('No option selected')
          });
        }
        return;
      }
      var optionId = !application.program_esl || !esl ? Number(intakes === null || intakes === void 0 ? void 0 : (_intakes$find = intakes.find(function (currIntake) {
        return currIntake.startDate === option;
      })) === null || _intakes$find === void 0 ? void 0 : _intakes$find.id) : Number(intakesESL === null || intakesESL === void 0 ? void 0 : (_intakesESL$find = intakesESL.find(function (currIntake) {
        return currIntake.startDate === option;
      })) === null || _intakesESL$find === void 0 ? void 0 : _intakesESL$find.id);
      if (!optionId) {
        toastr.error('There was a problem updating intake, please try reloading the page.');
        trackEvent({
          event: 'Single Application - Application Intake - Failed To Load Program Intakes',
          error: new Error('No optionId found')
        });
        return;
      }
      if (isEslGapValid(esl, application, option)) {
        onChange(optionId, option);
        return;
      }
      toastr.error("The ESL and Academic start dates for Application #".concat(application.id, " must be ").concat(application.program_esl.min_length, " months apart"));
    };
  }
}), withProps(function (_ref6) {
  var application = _ref6.application,
    esl = _ref6.esl,
    dropdownOptions = _ref6.dropdownOptions;
  if (application) {
    return {
      dropdownOptions: getMinEslGapRespectedOptions(esl, application, dropdownOptions)
    };
  }
}), withStateHandlers({
  isOpen: false
}, {
  onBlur: function onBlur() {
    return function () {
      return {
        isOpen: false
      };
    };
  },
  onOpen: function onOpen() {
    return function () {
      return {
        isOpen: true
      };
    };
  }
}), withProps(function (_ref7) {
  var dropdownOptions = _ref7.dropdownOptions,
    isOpen = _ref7.isOpen,
    application = _ref7.application,
    esl = _ref7.esl;
  if (application) {
    return {
      dropdownOptions: optionsWithPrevInvalidIntake(dropdownOptions, isOpen, application, esl)
    };
  }
}));
var formatDeadline = function formatDeadline(deadline) {
  if (!deadline) {
    return undefined;
  }
  var today = new Date();
  var submissionDeadlineDate = new Date(deadline);
  return isAfter(submissionDeadlineDate, today) && differenceInDays(submissionDeadlineDate, today) <= 3 ? format(submissionDeadlineDate, 'MMM dd, yyyy, hh:mma, O') : format(submissionDeadlineDate, 'MMM dd, yyyy');
};
export { generateIntakeTooltip, getIntakeStatusColor, getMinEslGapRespectedOptions, getIntakeStatusText } from "./utils";
export default enhancer(ApplicationIntake);